/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Content_LabelInputs */

const tr_mesafeli_s3_content_label = /** @type {(inputs: Mesafeli_S3_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri İçeriği:`)
};

const en_mesafeli_s3_content_label = /** @type {(inputs: Mesafeli_S3_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer Content:`)
};

const de_mesafeli_s3_content_label = /** @type {(inputs: Mesafeli_S3_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundeninhalte:`)
};

const ru_mesafeli_s3_content_label = /** @type {(inputs: Mesafeli_S3_Content_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент Клиента:`)
};

/**
* | output |
* | --- |
* | "Customer Content:" |
*
* @param {Mesafeli_S3_Content_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_content_label = /** @type {((inputs?: Mesafeli_S3_Content_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Content_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_content_label(inputs)
	if (locale === "de") return de_mesafeli_s3_content_label(inputs)
	if (locale === "ru") return ru_mesafeli_s3_content_label(inputs)
	return tr_mesafeli_s3_content_label(inputs)
});